import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=0a2eab97"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=0a2eab97&prod&lang=scss"
import style1 from "./VendorList.vue?vue&type=style&index=1&id=0a2eab97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports